export const API_NAME = 'auth';
